import { PROVIDER_TYPES } from '@root/src/vars/general'

export const DH_APP_URL = 'https://app.crmmsk.ru'

export const COMM_CONTROL_PROVIDER_TYPES = [
    PROVIDER_TYPES.whatsappBasis,
    PROVIDER_TYPES.whatsappApi,
    PROVIDER_TYPES.whatsappDh,
    PROVIDER_TYPES.telegramApi,
    PROVIDER_TYPES.telegramDh,
    PROVIDER_TYPES.maxBasis,
]

export const STARTER_PACK_MDI_ICONS = {
    base: 'mdi-database-outline',
    cascade: 'mdi-sort-descending',
    cohort: 'mdi-chart-bar',
    forgot: 'mdi-account-clock-outline',
    hot: 'mdi-fire',
    invite: 'mdi-email-outline',
    msg: 'mdi-message-text-outline',
    notify: 'mdi-bell-outline',
    phone: 'mdi-phone-outgoing',
    phone2: 'mdi-phone-check',
    report: 'mdi-file-chart-outline',
    review: 'mdi-star-outline',
    stoplist: 'mdi-cancel',
    vacation: 'mdi-beach',
}

export const ROLE_LABELS = {
    admin: { label: 'Администратор', className: 'admin' },
    master: { label: 'Мастер', className: 'master' },
    manager: { label: 'Управляющий', className: 'manager' },
}

export const COMM_HELP_URL = 'https://dataheroes.platrum.ru/help?slug=4774-dublirovanie-perepiski-v-tg-kopiya'

export const CASCADE_GATE_SCENARIO_ID = 3

export const YCLIENTS_SCENARIO_IDS = [1, 12]

export const STARTER_PACK_SAVE_ACCESS_DENIED_HINT = 'Недостаточно прав, обратитесь к владельцу'

export const STARTER_PACK_DISABLE_CONFIRM_MESSAGES = {
    applyDeauthContacts:
        'При отключении данной функции все контакты будут удалены из получателей.\nДля подключения уведомлений Вам нужно будет заново сделать подключение.',
    applyCommControl:
        'При отключении данной функции все контакты, которым дублируется переписка, будут удалены из получателей.\nДля подключения уведомлений Вам нужно будет заново сделать подключение.',
}
